import React from 'react';

export default function FileNav({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between overflow-x-scroll border-b px-8 py-3 dark:border-brand-dark-50 dark:text-brand-light-25">
      {children}
    </div>
  );
}
